/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import T from 'aegisv2/Text';

import { randomizer } from 'Utils';
import { CourseCardSkeleton } from 'Shared/CourseCardV3/skeletons';
import Loadable from 'Shared/Loadable';

import CourseList from 'Jsx/Catalog/containers/CourseList';
import { ContainerDesktop } from 'Jsx/Catalog/ui/Responsive';
import { CourseCardWrapper } from 'Jsx/Catalog/ui/CourseCardWrapper';
import { secondaryMain, primaryText } from 'crehana-ui/styles/colors';
import { ShowMore } from '../ui';

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  @media (min-width: 475px) {
    ${'' /* course-card-slider has 12 padding top */}
    margin-bottom: 12px;
  }
`;

const SkeletonStyled = styled(CourseCardSkeleton)`
  padding-top: 12px;
`;

const Title = styled.h1`
  letter-spacing: -0.01em;
  font-family: Gilroy, Arial, sans-serif;
  font-weight: 700;
  color: ${primaryText};
  font-size: 16px;
  line-height: 24px;
  @media (min-width: 600px) {
    line-height: 32px;
    font-size: 22.428px;
  }
`;

class CourseListSlider extends Component {
  render() {
    const {
      loading,
      title,
      courses,
      // skeletonItems,
      courseIdsOwned,
      addCourseToCart,
      removeCourseFromCart,
      isUserLogged,
      user,
      link,
      linkText,
      loadingCartButton,
      isOrganization,
      name,
      hasMainTitle,
      userLanguage,
    } = this.props;
    // const idsInCart = courseIdsOwned.map(id => id.toString());
    const params = {
      slidesToShow: 4,
      slidesToScroll: 4,
      className: 'course-card-slider',
      responsive: [
        {
          breakpoint: 1680,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 475,
          settings: {
            slidesToShow: 1.3,
            slidesToScroll: 1,
          },
        },
      ],
      arrowTop: '108px',
    };

    if (!loading && courses.length === 0) {
      return null;
    }

    const itemsPerRow = {
      1680: 4,
      1440: 3,
      1280: 3,
      1024: 3,
    };

    const Loader = (
      <div
        style={{
          display: 'flex',
          overflow: 'hidden',
          flexFlow: 'row nowrap',
        }}
      >
        {Array.from({ length: 4 }).map(() => (
          <CourseCardWrapper
            itemsPerRow={itemsPerRow}
            key={randomizer.getString()}
            onRow
          >
            <SkeletonStyled />
          </CourseCardWrapper>
        ))}
      </div>
    );

    const showSlider =
      typeof window === 'undefined' ? false : window.innerWidth > 600;

    return (
      <div>
        <TitleWrapper>
          {hasMainTitle ? (
            <Title>{title}</Title>
          ) : (
            <Title as="span" bold s>
              {title}
            </Title>
          )}
          {link && linkText && (
            <ContainerDesktop>
              <a href={link}>
                <T color={secondaryMain} xs bold>
                  {linkText}
                </T>
              </a>
            </ContainerDesktop>
          )}
        </TitleWrapper>
        {loading ? (
          Loader
        ) : showSlider ? (
          <Loadable
            module={() =>
              import(/* webpackChunkName: "course-list-slider" */ './Slider')
            }
            loading={loading}
            params={params}
            courses={courses}
            addCourseToCart={addCourseToCart}
            removeCourseFromCart={removeCourseFromCart}
            isUserLogged={isUserLogged}
            user={user}
            isOrganization={isOrganization}
            loadingCartButton={loadingCartButton}
            name={name}
            userLanguage={userLanguage}
            Loader={Loader}
          />
        ) : (
          <React.Fragment>
            <CourseList
              skeletonItems={4}
              courses={courses.slice(0, 4)}
              loading={loading}
              isUserLogged={isUserLogged}
              user={user}
              courseIdsOwned={courseIdsOwned}
              removeCourseFromCart={removeCourseFromCart}
              addCourseToCart={addCourseToCart}
              loadingCartButton={loadingCartButton}
              userLanguage={userLanguage}
              isMobile
            />
            {link && linkText && (
              <ShowMore href={link}>
                <T size={13.86} color={secondaryMain} xs bold>
                  {linkText}
                </T>
              </ShowMore>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

CourseListSlider.propTypes = {
  user: PropTypes.shape({}),
  loading: PropTypes.bool,
  title: PropTypes.string,
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      affiliateCommission: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      affiliateUrl: PropTypes.string,
      buyUrl: PropTypes.string,
      discount: PropTypes.number,
      number: PropTypes.string,
      id: PropTypes.number,
      imagePlaceholder: PropTypes.string,
      inShoppingCart: PropTypes.bool,
      isEnrolled: PropTypes.bool,
      isEnrollment: PropTypes.bool,
      level: PropTypes.shape({
        name: PropTypes.string,
      }),
      originalId: PropTypes.number,
      prices: PropTypes.shape({
        currencySymbol: PropTypes.string,
        price: PropTypes.number,
        realPrice: PropTypes.number,
      }),
      promoImage: PropTypes.string,
      score: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number]),
      title: PropTypes.string,
      url: PropTypes.string,
      professor: PropTypes.shape({
        fullName: PropTypes.string,
      }),
    }),
  ),
  skeletonItems: PropTypes.number,
  courseIdsOwned: PropTypes.arrayOf(PropTypes.number).isRequired,
  removeCourseFromCart: PropTypes.func.isRequired,
  addCourseToCart: PropTypes.func.isRequired,
  userId: PropTypes.number,
  isUserLogged: PropTypes.bool,
  link: PropTypes.string,
  linkText: PropTypes.string,
  loadingCartButton: PropTypes.bool.isRequired,
  isOrganization: PropTypes.bool,
  name: PropTypes.string.isRequired,
  userLanguage: PropTypes.string.isRequired,
  hasMainTitle: PropTypes.bool,
};

CourseListSlider.defaultProps = {
  hasMainTitle: false,
  isOrganization: false,
  user: null,
  loading: false,
  title: null,
  courses: undefined,
  seeAllText: null,
  fullWidthButton: false,
  helpText: null,
  skeletonItems: 0,
  onSeeMore: undefined,
  userId: null,
  isUserLogged: false,
  link: '',
  linkText: '',
};

export default CourseListSlider;
